/* src/app/views/live-view/shelf-talkers/print-shelf-talker-live-view/print-shelf-talker-live-view.component.scss */
:host {
  display: contents;
}
/*# sourceMappingURL=print-shelf-talker-live-view.component.css.map */
